<template>
	<header class="gridx">
		<vs-navbar
      v-model="indexActive"
      :color="topbarColor"
      class="topnavbar" text-color="rgba(255,255,255,0.7)" active-text-color="rgba(255,255,255,1)">
      <!---
      Template logo
      -->
      <div slot="title" class="themelogo">
        <img class="imgC" :src="logo" v-if="logo" alt="Dashboard"/>
        <img class="imgP" :src="logopsinet" v-if="logopsinet" alt="Dashboard"/>
      </div>
      <!---
      Mobile toggle
      -->
      <div slot="title">
        <div class="hiddenDesktop cursor-pointer" @click.stop="activeSidebar"><vs-icon color="darkgreen" icon="menu"></vs-icon></div>
      </div>
      <!---
      Craete new dd
      -->
      <!-- <vs-button color="danger" href="https://www.wrappixel.com" type="filled">Upgrade to Pro</vs-button> -->
      <vs-spacer></vs-spacer>
      <div>
        <span class="text-title" v-if="title">{{ title }}</span>
      </div>
      <vs-spacer></vs-spacer>
      <!---
      Craete new dd
      -->
      <div>
        <vs-dropdown vs-trigger-click left class="cursor-pointer pr-2 pl-2 ml-1 mr-md-3">
          <!-- <span class="text-title"><h6 class="ps_user_role">{{user.role}} profile</h6></span> -->
          <a class="text-color user-image" href="#"><img src="@/assets/images/users/1.jpg" alt="User"/></a>
          <vs-dropdown-menu class="topbar-dd">
            <h6 class="ps_user_role">{{user.role}}</h6>
            <h6 class="ps_user_role">{{user.userEmail}}</h6>
              <!-- <vs-dropdown-item><vs-icon icon="person_outline" class="mr-1"></vs-icon> My Profile</vs-dropdown-item>
              <vs-dropdown-item><vs-icon icon="sentiment_very_satisfied" class="mr-1"></vs-icon> My Balance</vs-dropdown-item>
              <vs-dropdown-item><vs-icon icon="mail_outline" class="mr-1"></vs-icon> Inbox</vs-dropdown-item> -->
              <hr class="mb-1" />
              <vs-dropdown-item v-if="verificateSesion == false" @click="logout"><vs-icon icon="logout" class="mr-1"></vs-icon> Ingresar </vs-dropdown-item>
              <vs-dropdown-item v-if="verificateSesion" @click="logout"><vs-icon icon="logout" class="mr-1"></vs-icon> Salir</vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </vs-navbar>
	</header>
</template>

<script>
export default {
	name : 'Navbar',
  props: {
      topbarColor: {
          type: String,
          default: "#2962ff",
      },
      title: {
            type: String,
      },
      logopsinet: {
            type: String,
      },
      logo: {
            type: String
      },
      user: {
        type: Object,
        required: true,
      },
  },
  data:()=>({
    indexActive: 0,
    showToggle: false,
  }),

  methods: {
      //This is for sidebar trigger in mobile
      activeSidebar() {
          this.$store.commit('IS_SIDEBAR_ACTIVE', true);
      },
      logout(){
        localStorage.clear()
        this.$router.push('/')
      }
	},
  computed: {
    verificateSesion: function (){
          return localStorage.getItem('token') != null
    }
  }
}
</script>
<style>
  .imgC{
	height: 40px;
	width: 150px;
  }
  .imgP{
	height: 30px;
	width: 150px;
  margin-right: 10px;
  }
  .text-color, .text-title{
  color: #3a9ba9;
  }
  .text-title{
    font-size: 2em;
    font-weight: bold;
    float: left !important;
  }
  .ps_user_role{
    margin: 10px;
  }
</style>
